import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const MaterialsRepository = {
  fetchAll: (payload) => {
    return Axios({
      url: SETTINGS.API_URL + "materials",
      method: "GET",
      params: {
        page: payload.page,
        size: payload.size,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        searchParams: payload.searchParams,
      },
    });
  },

  fetchAllWithoutPaging: () => {
    return Axios({
      url: SETTINGS.API_URL + "materials/all",
      method: "GET",
    });
  },

  get: (id) => {
    return Axios.get(`${SETTINGS.API_URL}materials/${id}`);
  },

  create: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}materials`,
      method: "POST",
      data: data,
    });
  },

  update: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}materials`,
      method: "PUT",
      data: data,
    });
  },

  delete: (id) => {
    return Axios.delete(`${SETTINGS.API_URL}materials/${id}`);
  },
};
